/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface InviteUserFromUserRequestUserAccountRoleUserAccountGroupInner
 */
export interface InviteUserFromUserRequestUserAccountRoleUserAccountGroupInner {
    /**
     * Role to assign
     * @type {string}
     * @memberof InviteUserFromUserRequestUserAccountRoleUserAccountGroupInner
     */
    'role': InviteUserFromUserRequestUserAccountRoleUserAccountGroupInnerRoleEnum;
    /**
     * Resource ID for the role
     * @type {string}
     * @memberof InviteUserFromUserRequestUserAccountRoleUserAccountGroupInner
     */
    'resourceId': string;
}

export const InviteUserFromUserRequestUserAccountRoleUserAccountGroupInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type InviteUserFromUserRequestUserAccountRoleUserAccountGroupInnerRoleEnum = typeof InviteUserFromUserRequestUserAccountRoleUserAccountGroupInnerRoleEnum[keyof typeof InviteUserFromUserRequestUserAccountRoleUserAccountGroupInnerRoleEnum];


